import { type FC } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { useBoolean } from 'usehooks-ts'

import { FormControl, FormHelperText, FormLabel, Input } from 'base-ui'

import { LoginRegistrationUserLoginShowPassword } from '../../../login-registration/components/LoginRegistrationUserLoginForm/LoginRegistrationUserLoginShowPassword'

import { type PasswordLoginFormData } from './useLoginRegistrationUserPasswordLoginSubmission'

export const LoginRegistrationUserPasswordField: FC = () => {
  const intl = useIntl()
  const { toggle: toggleShowPassword, value: showPassword } = useBoolean(false)
  const {
    control,
    formState: { errors },
    register,
  } = useFormContext<PasswordLoginFormData>()
  const password = useWatch({ control, name: 'password' })
  const { required, ...passwordInputProps } = register('password', {
    required: intl.formatMessage({ id: 'form.error.input.missing' }),
  })
  const passwordError = errors.password?.message

  return (
    <FormControl
      className="mb-3.5"
      error={Boolean(passwordError)}
      required={required}
      value={password}
    >
      <FormLabel htmlFor="login-modal-password">
        {intl.formatMessage({ id: 'general.label.password' })}
      </FormLabel>
      <Input
        endAdornment={
          <LoginRegistrationUserLoginShowPassword
            showPassword={showPassword}
            toggleShowPassword={toggleShowPassword}
          />
        }
        id="login-modal-password"
        slotProps={{
          input: { 'data-qa-id': 'login-form-password' },
        }}
        type={showPassword ? 'text' : 'password'}
        {...passwordInputProps}
      />
      {passwordError ? (
        <FormHelperText data-qa-id="loginForm-password-error-msg">
          {passwordError}
        </FormHelperText>
      ) : null}
    </FormControl>
  )
}
